import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { depoConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-depo',
    template: ''
})
export class DepoComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];
      // if (inApp) {
      //   depoConfig.redirectUri = depoConfig.redirectUri + '?inApp=true';
      // }

      const banner = params['banner'];
      let channel = params['channel'];
      const tenanthost = params['tenanthost'];

      if (tenanthost === 'eb') {
        channel = 'ebanking';
      }else{
        channel = 'app';
      }

      const queryParams = [];

      if (banner) {
        queryParams.push('banner=' + banner);
      }

      if (channel) {
        queryParams.push('channel=' + channel);
      }

      if (inApp) {
        queryParams.push('inApp=true');
      }
      console.log('queryParams', queryParams);

      if (queryParams.length > 0) {
        depoConfig.redirectUri += '?' + queryParams.join('&');
      }
    });
  }

  ngOnInit(): void {
    this.loginService.login(depoConfig);
  }
}
